import { StoreModel } from '@common/models';
import { createSelectedHook } from '@core/utils/createSelectedHook';
import { selectRestorableStoreId, selectSelectedStore } from '@redux/slices/storeSlice';

import { useStores } from './useStores';

const useStoresData = (): StoreModel[] => {
    const { stores } = useStores();
    return stores;
};

export const useSelectedStore = createSelectedHook({
    selector: selectSelectedStore,
    restorableSelector: selectRestorableStoreId,
    apiQueryHook: useStoresData,
    selectRestoredValue: ({ apiHookResponse, restorableValue, selectedValue }) =>
        selectedValue || apiHookResponse.find((store) => store.companyId === restorableValue),
    shouldReturnDefault: ({ selectedValue, apiHookResponse }) =>
        !selectedValue || !apiHookResponse.find((store) => store.companyId === selectedValue.companyId),
    selectDefaultValue: ({ apiHookResponse }) => apiHookResponse[0],
});
